import React from 'react';

interface GarantiaSectionProps {
  scrollToSection: (id: string) => void;
}

export default function GarantiaSection({ scrollToSection }: GarantiaSectionProps) {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block bg-teal-50 text-teal-700 text-xs font-bold uppercase tracking-widest px-5 py-2 rounded-full mb-4">
            Confiança e Transparência
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 font-serif">
            Por que confiar seu caso a nós?
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Atendimento especializado em direito do passageiro aéreo com total transparência e compromisso com seus direitos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:border-teal-400 hover:shadow-xl transition-all duration-300 text-center">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-shield-check-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Advogada Especializada
            </h3>
            <p className="text-gray-600 leading-relaxed mb-3">
              Dra. Skarlett Marcelino
            </p>
            <p className="text-sm font-semibold text-teal-600">
              OAB/ES 34.325
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:border-teal-400 hover:shadow-xl transition-all duration-300 text-center">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-map-pin-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Atendimento Nacional
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Atendemos clientes em todo o Brasil de forma 100% online, com a mesma qualidade e segurança.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:border-teal-400 hover:shadow-xl transition-all duration-300 text-center">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-money-dollar-circle-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Só paga se ganhar
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Você não paga nada adiantado. Nossos honorários só são cobrados se você receber a indenização.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 border border-gray-200 hover:border-teal-400 hover:shadow-xl transition-all duration-300 text-center">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-message-3-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Comunicação Clara
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Sem juridiquês. Explicamos tudo de forma simples e mantemos você informado em cada etapa do processo.
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-10 text-center text-white">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-3xl font-bold mb-6">
              Suas garantias ao trabalhar conosco
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
              <div className="flex items-start gap-3">
                <i className="ri-check-double-line text-2xl text-teal-200 mt-1 flex-shrink-0"></i>
                <div>
                  <p className="font-bold mb-1">Análise 100% Gratuita</p>
                  <p className="text-white/90 text-sm">Avaliamos seu caso sem cobrar nada</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-double-line text-2xl text-teal-200 mt-1 flex-shrink-0"></i>
                <div>
                  <p className="font-bold mb-1">Sem Compromisso Inicial</p>
                  <p className="text-white/90 text-sm">Você decide se quer seguir em frente</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-double-line text-2xl text-teal-200 mt-1 flex-shrink-0"></i>
                <div>
                  <p className="font-bold mb-1">Zero Custo Adiantado</p>
                  <p className="text-white/90 text-sm">Não paga nada para começar</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-double-line text-2xl text-teal-200 mt-1 flex-shrink-0"></i>
                <div>
                  <p className="font-bold mb-1">Sigilo Total</p>
                  <p className="text-white/90 text-sm">Suas informações são confidenciais</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-double-line text-2xl text-teal-200 mt-1 flex-shrink-0"></i>
                <div>
                  <p className="font-bold mb-1">Resposta Rápida</p>
                  <p className="text-white/90 text-sm">Retorno em até 24 horas</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-double-line text-2xl text-teal-200 mt-1 flex-shrink-0"></i>
                <div>
                  <p className="font-bold mb-1">Atendimento Humanizado</p>
                  <p className="text-white/90 text-sm">Tratamos você com respeito e atenção</p>
                </div>
              </div>
            </div>
            <button
              onClick={() => scrollToSection('contato')}
              className="mt-10 inline-flex items-center gap-3 bg-white text-teal-600 px-10 py-5 rounded-full text-lg font-bold uppercase transition-all duration-300 hover:scale-105 hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-user-heart-line text-xl"></i>
              Quero Essa Segurança no Meu Caso
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
